import { useSearchParams } from 'next/navigation';

const VALID_DATE_QUERY = 'till';

export const useValidDate = (initialDate?: string) => {
  const searchParams = useSearchParams();
  const rawDate = searchParams.get(VALID_DATE_QUERY);

  if (!(rawDate && /^\d{4}$/.test(rawDate))) {
    return initialDate;
  }

  const month = rawDate.substring(0, 2);
  const yearShort = rawDate.substring(2, 4);
  const fullYear = `20${yearShort}`;

  return `10.${month}.${fullYear}`;
};
